//引入、配置路由的相关信息
import Vue from 'vue'
import VueRouter from 'vue-router'
//1.Vue.use安装插件
Vue.use(VueRouter)

const Home = () => import('@/views/Home');
const Login = () => import('@/views/Login');
// const One = () => import('@/views/One');
// const Step = () => import('@/views/Step');

//=====demo==========================
const Demo = () => import('@/views/Demo');
const Video = () => import('@/views/Video');

//=====demo_1==========================
const Demo_1 = () => import('@/views/demo1/Home');
const Demo_1_end = () => import('@/views/demo1/End');

//=====demo_0==========================
const Demo_0 = () => import('@/views/demo/Home');
const Fla = () => import('@/views/demo/Fla');
const RenCheck = () => import('@/views/demo/RenCheck');
const Ren = () => import('@/views/demo/Ren');
const Team = () => import('@/views/demo/Team');
const My = () => import('@/views/demo/My');

//=====one==========================
const One = () => import('@/views/one/Home');
const OneFla = () => import('@/views/one/Fla');
const OneRenCheck = () => import('@/views/one/RenCheck');
const OneRen = () => import('@/views/one/Ren');
const OneTeam = () => import('@/views/one/Team');
const OneMy = () => import('@/views/one/My');

//=====two==========================
const Two = () => import('@/views/two/Home');
const TwoFla = () => import('@/views/two/Fla');
const TwoRenCheck = () => import('@/views/two/RenCheck');
const TwoRen = () => import('@/views/two/Ren');
const TwoTeam = () => import('@/views/two/Team');
const TwoMy = () => import('@/views/two/My');

const routes =[
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/home",
        name: "Home",
        component: Home,
    }
    ,{
        path: "/login",
        name: "Login",
        component: Login,
    }
    // ,{
    //     path: "/one",
    //     name: "One",
    //     component: One,
    // }
    // ,{
    //     path: "/step",
    //     name: "Step",
    //     component: Step,
    // }
    //=====demo==========================
    ,{
        path: "/video",
        name: "Video",
        component: Video,
    }
    ,{
        path: "/demo",
        name: "Demo",
        component: Demo,
    }
    ,{
        path: "/demo_1",
        name: "Demo_1",
        component: Demo_1,
    }
    ,{
        path: "/demo_1_end",
        name: "Demo_1_end",
        component: Demo_1_end,
    }
    ,{
        path: "/demo_0",
        name: "Demo_0",
        component: Demo_0,
    }
    ,{
        path: "/demo/ren",
        name: "Ren",
        component: Ren,
    }
    ,{
        path: "/demo/ren_check",
        name: "RenCheck",
        component: RenCheck,
    }
    ,{
        path: "/demo/fla",
        name: "Fla",
        component: Fla,
    }
    ,{
        path: "/demo/team",
        name: "Team",
        component: Team,
    }
    ,{
        path: "/demo/my",
        name: "My",
        component: My,
    }
    //=====one==========================
    ,{
        path: "/one",
        name: "One",
        component: One,
    }
    ,{
        path: "/one/fla",
        name: "OneFla",
        component: OneFla,
    }
    ,{
        path: "/one/ren_check",
        name: "OneRenCheck",
        component: OneRenCheck,
    }
    ,{
        path: "/one/ren",
        name: "OneRen",
        component: OneRen,
    }
    ,{
        path: "/one/team",
        name: "OneTeam",
        component: OneTeam,
    }
    ,{
        path: "/one/my",
        name: "OneMy",
        component: OneMy,
    }
    //=====two==========================
    ,{
        path: "/two",
        name: "Two",
        component: Two,
    }
    ,{
        path: "/two/fla",
        name: "TwoFla",
        component: TwoFla,
    }
    ,{
        path: "/two/ren_check",
        name: "TwoRenCheck",
        component: TwoRenCheck,
    }
    ,{
        path: "/two/ren",
        name: "TwoRen",
        component: TwoRen,
    }
    ,{
        path: "/two/team",
        name: "TwoTeam",
        component: TwoTeam,
    }
    ,{
        path: "/two/my",
        name: "TwoMy",
        component: TwoMy,
    }
]
//2.创建路由对象
const router = new VueRouter({
    // mode: "history",
    mode: "hash",
    base: process.env.BASE_URL,
    //配置路由与组件的关系
    routes,

})
//3.将router对象导出
export default router

